import { createSlice } from "@reduxjs/toolkit";

/**
 * loading 전역 상태 초기값
 * - count : 현재 진행 중인 요청 수
 * - visible : 로딩 UI 노출 여부
 */
const initialState = {
    count: 0,
    visible: false,
};

/**
 * loading Redux Slice
 * - 전역 로딩 상태 관리
 * - 요청 수 기준으로 로딩 UI 제어
 */
const loadingSlice = createSlice({
    name: "loading",
    initialState,
    reducers: {
        /**
         * 로딩 시작 처리
         * - 요청 카운트 증가
         * @param {Object} state - 현재 state
         */
        startLoading: (state) => {
            state.count += 1;
        },

        /**
         * 로딩 UI 노출 처리
         * @param {Object} state - 현재 state
         */
        showLoading: (state) => {
            state.visible = true;
        },

        /**
         * 로딩 종료 처리
         * - 요청 카운트 감소
         * - 모든 요청 종료 시 로딩 UI 숨김
         * @param {Object} state - 현재 state
         */
        endLoading: (state) => {
            state.count = Math.max(0, state.count - 1);
            if (state.count === 0) {
                state.visible = false;
            }
        },
    },
});

export const {
    startLoading,
    showLoading,
    endLoading,
} = loadingSlice.actions;

export default loadingSlice.reducer;